import { connect } from 'react-redux';
import { setHeatmapContextData } from '../store';
import HeatmapButtons from '../components/HeatmapButtons';

const mapStateToProps = state => {
  return {
    context: state.ui.heatmapContext,
    applicationInfo: state.api.current.applicationInfo,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setHeatmapContext: data => dispatch(setHeatmapContextData(data)),
  };
};

const ConnectedHeatmapButtons = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeatmapButtons);
export default ConnectedHeatmapButtons;
